import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IUsefulLinks } from "../usefullinksModel";

export const getAllUsefulLinks = createAsyncThunk(
  "UsefulLinks/FindAllUsefulLinks",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/UsefulLinks/FindAllUsefulLinks`,
        {
          ServiceName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching UsefulLinks:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createUsefulLinks = createAsyncThunk(
  "UsefulLinks/InsertUsefulLinks",
  async (UsefulLinksData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/UsefulLinks/InsertUsefulLinks`,
        UsefulLinksData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating UsefulLinks:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateUsefulLinks = createAsyncThunk(
  "UsefulLinks/UpdateUsefulLinks",
  async (UsefulLinksData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/UsefulLinks/UpdateUsefulLinks`,
        UsefulLinksData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating UsefulLinks :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteUsefulLinks = createAsyncThunk(
  "UsefulLinks/DeleteUsefulLinks",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/UsefulLinks/DeleteUsefulLinks`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting UsefulLinks :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getUsefulLinksByID = createAsyncThunk(
  "UsefulLinks/FindByIDUsefulLinks",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/UsefulLinks/FindByIDUsefulLinks`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Description: result.Description,
        WebsiteTitle: result.WebsiteTitle,
        WebsiteLink: result.WebsiteLink,
        IsDisplayMain: result.IsDisplayMain,
        IsActive: result.IsActive ? 1 : 2,
      } as IUsefulLinks;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching UsefulLinks :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveUsefulLinks = createAsyncThunk(
  "UsefulLinks/FindAllActiveUsefulLinks",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/UsefulLinks/FindAllActiveUsefulLinks`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching UsefulLinkses:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveUsefulLinks = createAsyncThunk(
  "UsefulLinks/ActiveInActiveUsefulLinks",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/UsefulLinks/ActiveInActiveUsefulLinks`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive UsefulLinks :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
